module.exports = __webpack_public_path__ + "img/arrow_right_grey.10da02d4.svg";